import { DashboardModuleListItem } from '@domain-group/suit-theme'

import usePricingPlan from '@hooks/usePricingPlan'

import type { PricingPlanModel } from '@models/types'

const PricingPlanListItem = (props: { pricingPlan: PricingPlanModel }) => {
  const { pricingPlan, pricingPlan: { id, title } } = props

  const pricingPlanPayload = usePricingPlan(pricingPlan)
  const {
    callbacks: { createOrEditPricingPlan },
  } = pricingPlanPayload

  return (
    <DashboardModuleListItem
      onClick={() => createOrEditPricingPlan()}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default PricingPlanListItem
